module.exports = __webpack_public_path__ + "img/ico_6.5a03876e.svg";